/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Menu Controls
import { NgcMenuModule } from '../controls/menu/ngc-menu.component';

/**
 * NGC Menu Module
 */
@NgModule({
    exports: [
        NgcMenuModule
    ]
})
export class NgcMenusModule {
}